<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
  data() {
    return {
      routerType: false,
    };
  },
  watch: {
    $route: {
      handler(val, oldval) {
        if (this.$route.path != "/") {
          this.routerType = true;
        } else {
          this.routerType = false;
        }
      },
    },
  },
  //方法集合
  methods: {},
  created() {
    if (this.$route.path != "/") {
      this.routerType = true;
    } else {
      this.routerType = false;
    }
  },
  mounted() {
    console.log("app mounted");
  },
};
</script>

<style>
@import "./assets/css/main.css";
html,
body,
#app {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
}

.OldBackground {
  background: #ffffff;
  width: 100%;
  height: 100%;
}

body,
div,
dl,
dt,
dd,
ul,
ol,
li,
h1,
h2,
h3,
h4,
h5,
h6,
pre,
code,
form,
fieldset,
legend,
input,
button,
textarea,
p,
blockquote,
th,
td {
  margin: 0;
  padding: 0;
}
body {
  background: #fff;
  color: #555;
  font-size: 14px;
  font-family: Helvetica, "San Francisco", "Microsoft Yahei", "微软雅黑",
    Heiti SC;
  min-width: 1200px;
}
td,
th,
caption {
  font-size: 14px;
}
h1,
h2,
h3,
h4,
h5,
h6 {
  font-weight: normal;
  font-size: 100%;
}
address,
caption,
cite,
code,
dfn,
em,
th,
var {
  font-style: normal;
  font-weight: normal;
}
a {
  color: #555;
  text-decoration: none;
}
a:hover {
  text-decoration: underline;
}
img {
  border: none;
}
ol,
ul,
li {
  list-style: none;
}
input,
textarea,
select,
button {
  font: 14px Verdana, Helvetica, Arial, sans-serif;
}
table {
  border-collapse: collapse;
}
html {
  overflow-y: auto;
}

.clearfix:after {
  content: ".";
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}
.clearfix {
  *zoom: 1;
}
</style>

<style lang="scss">
/* 全局滚动条样式统一 */
::-webkit-scrollbar {
  width: 10px; /*滚动条宽度*/
  height: 10px; /*滚动条高度*/
}
/*定义滚动条轨道 内阴影+圆角*/
::-webkit-scrollbar-track {
  // box-shadow: 0px 1px 3px #071e4a inset; /*滚动条的背景区域的内阴影*/
  border-radius: 10px; /*滚动条的背景区域的圆角*/
  // background-color: #fff; /*滚动条的背景颜色*/
}
/*定义滑块 内阴影+圆角*/
::-webkit-scrollbar-thumb {
  // box-shadow: 0px 1px 3px #00a0e9 inset; /*滚动条的内阴影*/
  border-radius: 10px; /*滚动条的圆角*/
  background-color: #eee; /*滚动条的背景颜色*/
  // background-color: #FF4D01; /*滚动条的背景颜色*/
  // #FF4D01
}
</style>



// WEBPACK FOOTER //
// src/App.vue